import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

// Características del módulo
const funciones = [
  "Control total de cada reparación: Registra intervenciones, piezas y tiempos de trabajo.",
  "Avisos de ITV y mantenimiento: Recibe alertas antes de caducidad.",
  "Gestión de tacógrafos: Mantén al día las inspecciones y evita sanciones.",
  "Historial completo de cada vehículo: Consulta cualquier intervención en segundos.",
  "Automatización de tareas: Reduce la carga administrativa y ahorra tiempo."
];

const GestionTalleres = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      <div className="fondo-aplicacion">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo Gestión de Talleres"
        />
        <div className="fondo-aplicacion-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo-aplicacion">Gestión de Talleres</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src={`/images/serviciosbackground.jpg`}
          alt="Gestión de Talleres 1"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Optimiza tu taller mecánico o flota con nuestro módulo para Sage 200. 
            Simplifica la gestión, evita imprevistos y mantén el control total de tus vehículos.
          </p>
          <p>
            Registra reparaciones, inspecciones y mantenimientos de manera automatizada 
            para que ningún detalle se pase por alto.
          </p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>🚗 ¿Qué puede hacer por ti?</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✅ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/gestiontalleres${num}.jpg`}
                alt={`Gestión de Talleres ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/gestiontalleres${num}.jpg`}
              alt={`Gestión de Talleres ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>

      <section className="cta fade-in">
        <h2>🔧 Haz que tu taller o flota funcione como un reloj</h2>
        <p>Maximiza la eficiencia con automatización e integración total con Sage 200.</p>
        <button className="btn-cta">Solicitar una Demo</button>
      </section>
    </div>
  );
};

export default GestionTalleres;
